import { useState } from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import VideoPlayer from '@/modules/content/common/VideoPlayer';
import useVideoAspect from '@/hooks/content/useVideoAspect';
import AuthorHeader from '@/modules/content/feed/reader/parts/AuthorHeader';
import TitleBlock from '@/modules/content/feed/reader/parts/TitleBlock';
import { TReaderDetails } from '@/modules/content/feed/reader/model/articleStructure';
import { readerCardProps } from '@/modules/content/feed/reader/model/readerStyles';
import { TContent } from '@/types/Content.types';

// A portrait video is capped in width so it doesn't run the full height of the reading
// column; landscape uses the full width.
const PORTRAIT_MAX_WIDTH = '380px';

const VideoBody = ({ content, details }: { content: TContent; details: TReaderDetails }) => {
  // Portrait uploads and Shorts are not 16:9 — size the frame to the video rather than
  // letterboxing it into a landscape box.
  const aspect = useVideoAspect(content);
  const [measured, setMeasured] = useState<number | null>(null);
  const ratio = measured ?? aspect.ratio;

  return (
    <VStack {...readerCardProps} align="stretch" gap="20px">
      <AuthorHeader content={content} />
      <TitleBlock content={content} />
      <Box alignSelf="center" width="100%" maxWidth={ratio < 1 ? PORTRAIT_MAX_WIDTH : '100%'}>
        <VideoPlayer
          source={details.source === 'youtube' ? 'youtube' : 'mux'}
          youtubeVideoId={details.youtube?.videoId}
          muxStatus={details.mux?.status}
          muxPlaybackId={details.mux?.playbackId}
          posterUrl={content.effectiveThumbnailUrl || details.mux?.thumbnailUrl}
          title={content.title}
          aspectRatio={ratio}
          onRatioDetected={setMeasured}
        />
      </Box>
      {details.fullDescription && (
        <Text fontSize="15px" color="text.darkBlue" whiteSpace="pre-wrap">
          {details.fullDescription}
        </Text>
      )}
    </VStack>
  );
};

export default VideoBody;
